import 'react-phone-input-2/lib/material.css';

import PI from 'react-phone-input-2';

// Fix for Minified React error #130 error in production
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const PhoneInput = PI.default ? PI.default : PI;
